<script lang="ts">
  import { MediumType } from '$lib/types/api/Publish';
  import Email from '$lib/assets/images/icons/email-new.svg';
  import Discord from '$lib/assets/images/icons/discord-new.svg';
  import Telegram from '$lib/assets/images/icons/telegram-new.svg';
  import DubClub from '$lib/assets/images/icons/plays-app-new.svg';
  import * as Avatar from '$lib/components/ui/avatar';

  interface Props {
    type: MediumType;
    size?: 'small' | 'medium' | 'large';
  }

  let { type, size = 'medium' }: Props = $props();

  let classes = $state('');
  switch (size) {
    case 'small':
      classes += 'min-w-[16px] max-w-[16px] min-h-[16px] max-h-[16px] rounded';
      break;
    case 'medium':
      classes += 'min-w-[20px] max-w-[20px] min-h-[20px] max-h-[20px] rounded';
      break;
    case 'large':
      classes += 'min-w-[24px] max-w-[24px] min-h-[24px] max-h-[24px] rounded';
      break;
    default:
      break;
  }

  let icon: string | undefined = $state();
  let alt = $state('');
  let iconClasses = $state('');
  switch (type) {
    case MediumType.Push:
      icon = DubClub;
      alt = 'Push';
      break;
    case MediumType.Email:
      icon = Email;
      alt = 'Email';
      iconClasses = 'bg-rose-500 p-[3px]';
      break;
    case MediumType.Telegram:
      icon = Telegram;
      alt = 'Telegram';
      iconClasses = 'bg-[#24A1DE] p-[3px]';
      break;
    case MediumType.Discord:
      icon = Discord;
      alt = 'Discord';
      iconClasses = 'bg-[#5865F2] p-[3px]';
      break;
    default:
      icon = DubClub;
      alt = 'App Store';
      break;
  }
</script>

<!-- <img src={icon} {alt} class="bg-red {classes} {iconClasses}" /> -->

<Avatar.Root class="b flex items-center justify-center {classes} {iconClasses}">
  <Avatar.Image src={icon} {alt} class="fill-red-500" />
  <Avatar.Fallback>{alt}</Avatar.Fallback>
</Avatar.Root>
